<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="handleSearch" layout="inline">
        <WorkOrderSearch :genre="'my-create'" @handleSearch="handleSearch" />
      </a-form>
    </div>
    <!-- 查询区域-END -->
    <!-- table区域-begin -->
    <div>
      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="stateName" slot-scope="stateName">
          <a-tag :key="stateName">{{ stateName }}</a-tag>
        </span>
        <span slot="principals" slot-scope="principals, record">
          <a-tag :key="principals" v-if="record.isEnd==0">{{ principals }}</a-tag>
        </span>
        <span slot="priority" slot-scope="priority, record">
          <span v-if="record.priority==2">
            <a-tag color="#faad14">紧急</a-tag>
          </span>
          <span v-else-if="record.priority==3">
            <a-tag color="#ff4d4f">非常紧急</a-tag>
          </span>
          <span v-else>
            <a-tag color="#52c41a">一般</a-tag>
          </span>
        </span>
        <span slot="isEnd" slot-scope="isEnd">
          <a-tag color="#52c41a" v-if="isEnd==0">否</a-tag>
          <a-tag color="#ff4d4f" v-else>是</a-tag>
        </span>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a-button @click="handleView(record)" icon="a-icon-edit" type="text" v-has="'process:list:myCreate:select'">查看</a-button>
          <a-divider type="vertical" />
          <a-button
            @click="handleReopen(record.id)"
            icon="a-icon-refresh-right"
            type="text"
            v-has="'process:list:myCreate:reopen'"
          >重开</a-button>
          <a-divider type="vertical" v-if="record.isEnd==0" />
          <a-button
            @click="handleUrge(record)"
            icon="a-icon-alarm-clock"
            type="text"
            v-has="'process:list:upcoming:urge'"
            v-if="record.isEnd==0"
          >催办</a-button>
        </span>
      </a-table>
    </div>

    <!-- <p-process-classify-modal ref="modalForm" @ok="modalFormOk"></p-process-classify-modal> -->
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WorkOrderSearch from '../components/search/index'
  import { getAction } from '@/api/manage'
  import { validatenull, validatenotnull } from '@/utils/validate'
  // import { cloneObject } from '@/utils/util'
  // import PProcessClassifyModal from './modules/PProcessClassifyModal'

  export default {
    name: 'PProcessClassifyList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      WorkOrderSearch,
      // PProcessClassifyModal
    },
    data () {
      return {
        query: {
          classify: '2'
        },
        disableMixinCreated: true,
        description: '工单分类管理页面',
        // 表头
        columns: [{
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '标题',
          align: "center",
          dataIndex: 'title'
        },
        {
          title: '流程',
          align: "center",
          dataIndex: 'processName'
        },
        {
          title: '当前状态',
          align: "center",
          dataIndex: 'stateName',
          scopedSlots: { customRender: 'stateName' },
        },
        {
          title: '当前处理人',
          align: "center",
          dataIndex: 'principals',
          scopedSlots: { customRender: 'principals' },
        },
        {
          title: '优先级',
          align: "center",
          dataIndex: 'priority',
          scopedSlots: { customRender: 'priority' },
        },
        {
          title: '是否结束',
          align: "center",
          dataIndex: 'isEnd',
          scopedSlots: { customRender: 'isEnd' },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: "center"
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          fixed: "right",
          width: 300,
          scopedSlots: { customRender: 'action' }
        }
        ],
        url: {
          workOrderList: "workorder/work-order/list",
          urgeWorkOrderUrl: "workorder/work-order/urge",
          reopenWorkOrderUrl: "workorder/work-order/reopen",
        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.getSuperFieldList()
      this.handleSearch()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'name', text: '名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'tenantId', text: '租户id', dictCode: '' })
        fieldList.push({ type: 'string', value: 'orgId', text: '公司id', dictCode: '' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态', dictCode: '' })
        this.superFieldList = fieldList
      },
      handleSearch (query) {
        if (validatenotnull(query)) {
          this.query = query
        }
        this.loading = true
        getAction(this.url.workOrderList, this.query).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records || res.result
            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {
          this.loading = false
        })
      },
      handleView (row) {
        this.$router.push({ path: '/process/handle-ticket', query: { workOrderId: row.id, processId: row.processId } })
      },
      handleReopen (id) {
        var that = this
        this.$confirm({
          title: '提示',
          content: `根据此工单新建一个新的工单?`,
          okType: 'warning',
          confirmButtonText: '确认', //确认按钮文字更换
          cancelButtonText: '取消', //取消按钮文字更换
          onOk () {
            return new Promise((resolve, reject) => {
              getAction(that.url.reopenWorkOrderUrl, {
                workOrderId: id
              }).then((res) => {
                if (res.success) {
                  that.dataSource = res.result.records || res.result
                  if (res.result.total) {
                    that.ipagination.total = res.result.total
                  } else {
                    that.ipagination.total = 0
                  }
                  that.handleSearch()
                  that.$message.success('重开成功!')
                } else {
                  that.$message.warning(res.message)
                }
              }).finally(() => {
                resolve(true)
              })
            })
          }
        })
      },
      handleUrge (row) {
        var that = this
        this.$confirm({
          title: '催办',
          content: `对此工单处理人进行催办通知提醒, 是否继续? （注意：十分钟内只能催办一次。）`,
          okType: 'warning',
          confirmButtonText: '确认', //确认按钮文字更换
          cancelButtonText: '取消', //取消按钮文字更换
          onOk () {
            return new Promise((resolve, reject) => {
              getAction(that.url.urgeWorkOrderUrl, {
                workOrderId: row.id
              }).then((res) => {
                if (res.success) {
                  that.dataSource = res.result.records || res.result
                  if (res.result.total) {
                    that.ipagination.total = res.result.total
                  } else {
                    that.ipagination.total = 0
                  }
                  that.$message.success('已进行催办通知!')
                } else {
                  that.$message.warning(res.message)
                }
              }).finally(() => {
                resolve(true)
              })
            })
          }
        })
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>